/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: any; output: any; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any; }
  /** Represents untyped JSON */
  JSON: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type Account = {
  __typename?: 'Account';
  accountUsers?: Maybe<Array<AccountUser>>;
  autoReload?: Maybe<Scalars['Boolean']['output']>;
  autoReloadAmount?: Maybe<Scalars['Int']['output']>;
  balance?: Maybe<Scalars['Int']['output']>;
  carts: AccountCarts;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdBy?: Maybe<User>;
  creator?: Maybe<User>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  delinquent: Scalars['Boolean']['output'];
  delinquentBatches: Array<Maybe<OrderBatch>>;
  delinquentFor?: Maybe<Scalars['Int']['output']>;
  delinquentSince?: Maybe<Scalars['ISO8601DateTime']['output']>;
  guardians?: Maybe<Array<AccountUser>>;
  id: Scalars['ID']['output'];
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paymentReference?: Maybe<Scalars['JSON']['output']>;
  reactions: Array<Maybe<ProductReaction>>;
  settings?: Maybe<Scalars['JSON']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type AccountCarts = {
  __typename?: 'AccountCarts';
  carts: Array<Maybe<Cart>>;
  final: Money;
  finalCents: Scalars['Int']['output'];
  finalCurrency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  subtotal: Money;
  subtotalCents: Scalars['Int']['output'];
  subtotalCurrency: Scalars['String']['output'];
  taxes: Money;
  taxesCents: Scalars['Int']['output'];
  taxesCurrency: Scalars['String']['output'];
  total: Money;
  totalCents: Scalars['Int']['output'];
  totalCurrency: Scalars['String']['output'];
};

export type AccountOrdersPayload = {
  __typename?: 'AccountOrdersPayload';
  aggregations: Array<Maybe<QueryAggregation>>;
  /** An array of errors that are presentable by the client. */
  errors: Array<Maybe<ClientError>>;
  pageInfo?: Maybe<PageInfo>;
  rowCount?: Maybe<Scalars['Int']['output']>;
  rows: Array<Maybe<Order>>;
};

export type AccountRole = {
  __typename?: 'AccountRole';
  account: Account;
  accountId: Scalars['ID']['output'];
  contextId: Scalars['ID']['output'];
  contextType: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  level: Scalars['Int']['output'];
  role: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
  userId: Scalars['ID']['output'];
};

export type AccountUser = {
  __typename?: 'AccountUser';
  account?: Maybe<Account>;
  accountId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<SchoolLocation>;
  locationId?: Maybe<Scalars['ID']['output']>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
  settings?: Maybe<Scalars['JSON']['output']>;
  subscription?: Maybe<Subscription>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of AddCartItem */
export type AddCartItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['ISO8601Date']['input'];
  menuId?: InputMaybe<Scalars['ID']['input']>;
  menuProductId?: InputMaybe<Scalars['ID']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  quantity: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
  variantId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of AddCartItem */
export type AddCartItemPayload = {
  __typename?: 'AddCartItemPayload';
  cart?: Maybe<Cart>;
  cartItem?: Maybe<CartItem>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** An array of errors that are presentable by the client. */
  errors: Array<ClientError>;
};

/** Autogenerated input type of AddCartItems */
export type AddCartItemsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  items: Array<CartItemInput>;
};

/** Autogenerated return type of AddCartItems */
export type AddCartItemsPayload = {
  __typename?: 'AddCartItemsPayload';
  cart?: Maybe<Cart>;
  cartItems?: Maybe<Array<CartItem>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** An array of errors that are presentable by the client. */
  errors: Array<ClientError>;
};

export type AddOn = {
  __typename?: 'AddOn';
  assets: Array<Maybe<Asset>>;
  catalogTags: Array<Maybe<CatalogTag>>;
  condiments: Array<Maybe<Condiment>>;
  cost?: Maybe<Money>;
  costCents: Scalars['Int']['output'];
  costCurrency: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Money>;
  priceCents: Scalars['Int']['output'];
  priceCurrency: Scalars['String']['output'];
  productCondiments: Array<Maybe<ProductCondiment>>;
  productPackaging?: Maybe<ProductPackaging>;
  productRecipe?: Maybe<ProductRecipe>;
  productSelectionGroups: Array<Maybe<ProductSelectionGroup>>;
  productUtensil?: Maybe<ProductUtensil>;
  productVessels: Array<Maybe<ProductVessel>>;
  reactions: Array<Maybe<ProductReaction>>;
  recipe?: Maybe<Recipe>;
  tags: Array<Maybe<Tag>>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of AddProductReaction */
export type AddProductReactionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['ID']['input'];
  reaction: ProductReactionEnum;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddProductReaction */
export type AddProductReactionPayload = {
  __typename?: 'AddProductReactionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ClientError>;
  reaction?: Maybe<ProductReaction>;
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  contactDisplayName?: Maybe<Scalars['String']['output']>;
  contactFirstName?: Maybe<Scalars['String']['output']>;
  contactLastName?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<Scalars['JSON']['output']>;
  country: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy?: Maybe<Scalars['ID']['output']>;
  deliveryInstructions?: Maybe<Scalars['String']['output']>;
  deliveryWindow?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  displayPhoneNumber?: Maybe<Scalars['String']['output']>;
  geohash?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  line3?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  parkingInstructions?: Maybe<Scalars['String']['output']>;
  phoneExtension?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  postalCode: Scalars['String']['output'];
  serviceStartTime?: Maybe<Scalars['String']['output']>;
  stateProvince: Scalars['String']['output'];
  stateProvinceOptions: Scalars['JSON']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of AdjustOrderItemQuantity */
export type AdjustOrderItemQuantityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the order item to modify */
  id: Scalars['ID']['input'];
  /** The new quantity for the item */
  quantity: Scalars['Int']['input'];
};

/** Autogenerated return type of AdjustOrderItemQuantity */
export type AdjustOrderItemQuantityPayload = {
  __typename?: 'AdjustOrderItemQuantityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** An array of errors that are presentable by the client. */
  errors: Array<ClientError>;
  item?: Maybe<OrderProduct>;
  order?: Maybe<Order>;
};

export type AdminRole = {
  __typename?: 'AdminRole';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  level: Scalars['Int']['output'];
  role: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
  userId: Scalars['ID']['output'];
};

export type Asset = {
  __typename?: 'Asset';
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  file: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  uri: Scalars['String']['output'];
};

export type Beverage = {
  __typename?: 'Beverage';
  assets: Array<Maybe<Asset>>;
  catalogTags: Array<Maybe<CatalogTag>>;
  cost?: Maybe<Money>;
  costCents: Scalars['Int']['output'];
  costCurrency: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Money>;
  priceCents: Scalars['Int']['output'];
  priceCurrency: Scalars['String']['output'];
  productPackaging?: Maybe<ProductPackaging>;
  productRecipe?: Maybe<ProductRecipe>;
  reactions: Array<Maybe<ProductReaction>>;
  recipe?: Maybe<Recipe>;
  tags: Array<Maybe<Tag>>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Bundle = {
  __typename?: 'Bundle';
  assets: Array<Maybe<Asset>>;
  bundleProducts: Array<Maybe<BundleProduct>>;
  catalogTags: Array<Maybe<CatalogTag>>;
  cost?: Maybe<Money>;
  costCents: Scalars['Int']['output'];
  costCurrency: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Money>;
  priceCents: Scalars['Int']['output'];
  priceCurrency: Scalars['String']['output'];
  productRecipe?: Maybe<ProductRecipe>;
  productSelectionGroups: Array<Maybe<ProductSelectionGroup>>;
  products: Array<Maybe<ConsumableUnion>>;
  reactions: Array<Maybe<ProductReaction>>;
  recipe?: Maybe<Recipe>;
  tags: Array<Maybe<Tag>>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type BundleProduct = {
  __typename?: 'BundleProduct';
  bundle: Bundle;
  createdAt: Scalars['ISO8601DateTime']['output'];
  default: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  linkedId: Scalars['ID']['output'];
  product: ConsumableUnion;
  productId: Scalars['ID']['output'];
  productSelectionGroup: ProductSelectionGroup;
  selectionGroupId: Scalars['ID']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of CancelOrder */
export type CancelOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the order to cancel */
  id: Scalars['ID']['input'];
};

/** Autogenerated input type of CancelOrderItem */
export type CancelOrderItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the order item to cancel */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of CancelOrderItem */
export type CancelOrderItemPayload = {
  __typename?: 'CancelOrderItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** An array of errors that are presentable by the client. */
  errors: Array<ClientError>;
  item?: Maybe<OrderProduct>;
  order?: Maybe<Order>;
};

/** Autogenerated return type of CancelOrder */
export type CancelOrderPayload = {
  __typename?: 'CancelOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** An array of errors that are presentable by the client. */
  errors: Array<ClientError>;
  order?: Maybe<Order>;
};

export type Cart = {
  __typename?: 'Cart';
  cartItems: Array<Maybe<CartItem>>;
  contents: Scalars['JSON']['output'];
  discounts: Money;
  discountsCents: Scalars['Int']['output'];
  discountsCurrency: Scalars['String']['output'];
  final: Money;
  finalCents: Scalars['Int']['output'];
  finalCurrency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  outstanding: Money;
  outstandingCents: Scalars['Int']['output'];
  outstandingCurrency: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  sponsored: Money;
  sponsoredCents: Scalars['Int']['output'];
  sponsoredCurrency: Scalars['String']['output'];
  subscription: Scalars['Boolean']['output'];
  subtotal: Money;
  subtotalCents: Scalars['Int']['output'];
  subtotalCurrency: Scalars['String']['output'];
  taxes: Money;
  taxesCents: Scalars['Int']['output'];
  taxesCurrency: Scalars['String']['output'];
  total: Money;
  totalCents: Scalars['Int']['output'];
  totalCurrency: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
  validation: CartValidationPayload;
};

export type CartItem = {
  __typename?: 'CartItem';
  cart: Cart;
  cartId: Scalars['ID']['output'];
  cartItem?: Maybe<CartItem>;
  cartItems: Array<Maybe<CartItem>>;
  date: Scalars['ISO8601Date']['output'];
  discounts: Money;
  discountsCents: Scalars['Int']['output'];
  discountsCurrency: Scalars['String']['output'];
  final: Money;
  finalCents: Scalars['Int']['output'];
  finalCurrency: Scalars['String']['output'];
  fullPrice: Money;
  fullPriceCents: Scalars['Int']['output'];
  fullPriceCurrency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  menu: Menu;
  menuProduct: MenuProduct;
  outstanding: Money;
  outstandingCents: Scalars['Int']['output'];
  outstandingCurrency: Scalars['String']['output'];
  price: Money;
  priceCents: Scalars['Int']['output'];
  priceCurrency: Scalars['String']['output'];
  product: Product;
  quantity: Scalars['Int']['output'];
  sponsored: Money;
  sponsoredCents: Scalars['Int']['output'];
  sponsoredCurrency: Scalars['String']['output'];
  subscription?: Maybe<Subscription>;
  subscriptionId?: Maybe<Scalars['ID']['output']>;
  subtotal: Money;
  subtotalCents: Scalars['Int']['output'];
  subtotalCurrency: Scalars['String']['output'];
  taxes: Money;
  taxesCents: Scalars['Int']['output'];
  taxesCurrency: Scalars['String']['output'];
  total: Money;
  totalCents: Scalars['Int']['output'];
  totalCurrency: Scalars['String']['output'];
  user: User;
  validation: CartItemValidation;
  variant: Variant;
};

export type CartItemInput = {
  date: Scalars['ISO8601Date']['input'];
  menuId?: InputMaybe<Scalars['ID']['input']>;
  menuProductId?: InputMaybe<Scalars['ID']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  quantity: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
  variantId?: InputMaybe<Scalars['ID']['input']>;
};

export type CartItemValidation = {
  __typename?: 'CartItemValidation';
  errors: Array<Maybe<ClientError>>;
  valid: Scalars['Boolean']['output'];
};

export type CartValidationItem = {
  __typename?: 'CartValidationItem';
  id: Scalars['ID']['output'];
  idx: Scalars['Int']['output'];
  menuId: Scalars['ID']['output'];
  menuProductId: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  productId: Scalars['ID']['output'];
  variantId: Scalars['ID']['output'];
};

export type CartValidationPayload = {
  __typename?: 'CartValidationPayload';
  isValid: Scalars['Boolean']['output'];
  unavailableItems?: Maybe<Array<Maybe<CartValidationItem>>>;
};

export type CatalogTag = {
  __typename?: 'CatalogTag';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  negate: Scalars['Boolean']['output'];
  sortOrder: Scalars['Int']['output'];
  tag: Tag;
  tagId: Scalars['ID']['output'];
  taggedId: Scalars['ID']['output'];
  taggedType: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of ChangePassword */
export type ChangePasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currentPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};

/** Autogenerated return type of ChangePassword */
export type ChangePasswordPayload = {
  __typename?: 'ChangePasswordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** An array of errors that are presentable by the client. */
  errors: Array<Maybe<ClientError>>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of ClearCart */
export type ClearCartPayload = {
  __typename?: 'ClearCartPayload';
  cart?: Maybe<Cart>;
  errors: Array<ClientError>;
};

/** A client-usable error, generally used in mutations */
export type ClientError = {
  __typename?: 'ClientError';
  /** An optional code that indicates the type of error */
  code?: Maybe<Scalars['String']['output']>;
  /** A user-presentable description of the error */
  message: Scalars['String']['output'];
  /** The input value from which this error was raised */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type Condiment = {
  __typename?: 'Condiment';
  assets: Array<Maybe<Asset>>;
  catalogTags: Array<Maybe<CatalogTag>>;
  cost?: Maybe<Money>;
  costCents: Scalars['Int']['output'];
  costCurrency: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Money>;
  priceCents: Scalars['Int']['output'];
  priceCurrency: Scalars['String']['output'];
  productRecipe?: Maybe<ProductRecipe>;
  reactions: Array<Maybe<ProductReaction>>;
  recipe?: Maybe<Recipe>;
  tags: Array<Maybe<Tag>>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ConsumableUnion = AddOn | Beverage | Dessert | MainDish | SideDish;

/** Autogenerated input type of CreateEntityAttribute */
export type CreateEntityAttributeInput = {
  allowsMultiple: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dataProvider?: InputMaybe<EntityAttributeDataProviderEnum>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  selectOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<EntityAttributeStatusEnum>;
  typeName: EntityAttributeTypeEnum;
};

/** Autogenerated return type of CreateEntityAttribute */
export type CreateEntityAttributePayload = {
  __typename?: 'CreateEntityAttributePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entityAttribute?: Maybe<EntityAttributeUnion>;
  /** An array of errors that are presentable by the client. */
  errors: Array<ClientError>;
};

/** Autogenerated input type of CreateEntityAttributeSelectOption */
export type CreateEntityAttributeSelectOptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** EntityAttribute ID */
  entityAttributeId: Scalars['ID']['input'];
  /** the value of the select option */
  value: Scalars['String']['input'];
};

/** Autogenerated return type of CreateEntityAttributeSelectOption */
export type CreateEntityAttributeSelectOptionPayload = {
  __typename?: 'CreateEntityAttributeSelectOptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entityAttributeSelectOption?: Maybe<EntityAttributeSelectOption>;
  /** An array of errors that are presentable by the client. */
  errors: Array<ClientError>;
};

/** Autogenerated input type of CreateOrdersFromCart */
export type CreateOrdersFromCartInput = {
  /** Account ID */
  accountId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Selected payment method ID */
  paymentMethodId: Scalars['String']['input'];
  /** User ID */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateOrdersFromCart */
export type CreateOrdersFromCartPayload = {
  __typename?: 'CreateOrdersFromCartPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** An array of errors that are presentable by the client. */
  errors: Array<ClientError>;
  isValid: Scalars['Boolean']['output'];
  orders: Array<Maybe<Order>>;
  unavailableItems: Array<Maybe<CartValidationItem>>;
};

/** Autogenerated input type of DeleteEntityAttribute */
export type DeleteEntityAttributeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** EntityAttribute ID */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteEntityAttribute */
export type DeleteEntityAttributePayload = {
  __typename?: 'DeleteEntityAttributePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entityAttribute?: Maybe<EntityAttributeUnion>;
  /** An array of errors that are presentable by the client. */
  errors: Array<ClientError>;
};

/** Autogenerated input type of DeleteEntityAttributeSelectOption */
export type DeleteEntityAttributeSelectOptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** EntityAttributeSelectOption ID */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteEntityAttributeSelectOption */
export type DeleteEntityAttributeSelectOptionPayload = {
  __typename?: 'DeleteEntityAttributeSelectOptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entityAttributeSelectOption?: Maybe<EntityAttributeSelectOption>;
  /** An array of errors that are presentable by the client. */
  errors: Array<ClientError>;
};

export type Dessert = {
  __typename?: 'Dessert';
  assets: Array<Maybe<Asset>>;
  catalogTags: Array<Maybe<CatalogTag>>;
  condiments: Array<Maybe<Condiment>>;
  cost?: Maybe<Money>;
  costCents: Scalars['Int']['output'];
  costCurrency: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Money>;
  priceCents: Scalars['Int']['output'];
  priceCurrency: Scalars['String']['output'];
  productCondiments: Array<Maybe<ProductCondiment>>;
  productPackaging?: Maybe<ProductPackaging>;
  productRecipe?: Maybe<ProductRecipe>;
  productSelectionGroups: Array<Maybe<ProductSelectionGroup>>;
  productUtensil?: Maybe<ProductUtensil>;
  productVessels: Array<Maybe<ProductVessel>>;
  reactions: Array<Maybe<ProductReaction>>;
  recipe?: Maybe<Recipe>;
  tags: Array<Maybe<Tag>>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type DishUnion = AddOn | Dessert | MainDish | SideDish;

export type Document = {
  __typename?: 'Document';
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  documentType: Scalars['String']['output'];
  documentTypeLabel: Scalars['String']['output'];
  documentTypeOptions: Array<SelectOption>;
  expired: Scalars['Boolean']['output'];
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  file: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['ID']['output']>;
  organization: Organization;
  organizationId: Scalars['ID']['output'];
  term?: Maybe<Term>;
  termId?: Maybe<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  uploader: User;
  uploaderId: Scalars['ID']['output'];
};

export enum EntityAttributeDataProviderEnum {
  Imports = 'imports',
  Ordo = 'ordo'
}

export type EntityAttributeNumber = {
  __typename?: 'EntityAttributeNumber';
  allowsMultiple: Scalars['Boolean']['output'];
  dataProvider: EntityAttributeDataProviderEnum;
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Indicates whether the EntityAttribute can be edited based on the data provider */
  locked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  status: EntityAttributeStatusEnum;
  typeName: EntityAttributeTypeEnum;
};

export type EntityAttributeSelect = {
  __typename?: 'EntityAttributeSelect';
  allowsMultiple: Scalars['Boolean']['output'];
  dataProvider: EntityAttributeDataProviderEnum;
  entityAttributeSelectOptions?: Maybe<Array<EntityAttributeSelectOption>>;
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Indicates whether the EntityAttribute can be edited based on the data provider */
  locked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  status: EntityAttributeStatusEnum;
  typeName: EntityAttributeTypeEnum;
};

export type EntityAttributeSelectOption = {
  __typename?: 'EntityAttributeSelectOption';
  entityAttribute: EntityAttributeSelect;
  id: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export enum EntityAttributeStatusEnum {
  Optional = 'optional',
  Required = 'required',
  Unused = 'unused'
}

export type EntityAttributeText = {
  __typename?: 'EntityAttributeText';
  allowsMultiple: Scalars['Boolean']['output'];
  dataProvider: EntityAttributeDataProviderEnum;
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Indicates whether the EntityAttribute can be edited based on the data provider */
  locked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  status: EntityAttributeStatusEnum;
  typeName: EntityAttributeTypeEnum;
};

export enum EntityAttributeTypeEnum {
  Boolean = 'boolean',
  Number = 'number',
  Select = 'select',
  Text = 'text'
}

/** Objects which are separated as subclasses based on their data type */
export type EntityAttributeUnion = EntityAttributeNumber | EntityAttributeSelect | EntityAttributeText;

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  gates: Array<Maybe<FeatureFlagGateUnion>>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type FeatureFlagActorGate = {
  __typename?: 'FeatureFlagActorGate';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FeatureFlagBooleanGate = {
  __typename?: 'FeatureFlagBooleanGate';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FeatureFlagExpressionGate = {
  __typename?: 'FeatureFlagExpressionGate';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FeatureFlagGateUnion = FeatureFlagActorGate | FeatureFlagBooleanGate | FeatureFlagExpressionGate | FeatureFlagGroupGate | FeatureFlagPercentActorsGate | FeatureFlagPercentTimeGate;

export type FeatureFlagGroupGate = {
  __typename?: 'FeatureFlagGroupGate';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FeatureFlagPercentActorsGate = {
  __typename?: 'FeatureFlagPercentActorsGate';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FeatureFlagPercentTimeGate = {
  __typename?: 'FeatureFlagPercentTimeGate';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Homeroom = {
  __typename?: 'Homeroom';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  roster?: Maybe<Roster>;
  rosterUsers?: Maybe<Array<RosterUser>>;
  term?: Maybe<Term>;
  termId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of IdentifyUser */
export type IdentifyUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of IdentifyUser */
export type IdentifyUserPayload = {
  __typename?: 'IdentifyUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** An array of errors that are presentable by the client. */
  errors: Array<ClientError>;
  user?: Maybe<User>;
};

/** Autogenerated input type of IgnoreTodo */
export type IgnoreTodoInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  todoId: Scalars['ID']['input'];
};

/** Autogenerated return type of IgnoreTodo */
export type IgnoreTodoPayload = {
  __typename?: 'IgnoreTodoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** An array of errors that are presentable by the client. */
  errors: Array<ClientError>;
  todo?: Maybe<TodoTask>;
};

export type Ingredient = {
  __typename?: 'Ingredient';
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type KioskUser = {
  __typename?: 'KioskUser';
  id: Scalars['ID']['output'];
  orderProducts: Array<Maybe<OrderProduct>>;
  posEnabled: Scalars['Boolean']['output'];
  user: User;
};

export type LineItem = {
  __typename?: 'LineItem';
  action: Scalars['String']['output'];
  amount: Money;
  amountCents: Scalars['Int']['output'];
  amountCurrency: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  metadata: Scalars['JSON']['output'];
  order: Order;
  quantity: Scalars['Int']['output'];
  subject?: Maybe<LineItemSubject>;
  subjectId?: Maybe<Scalars['ID']['output']>;
  subjectType?: Maybe<Scalars['String']['output']>;
  subtotal: Money;
  subtotalCents: Scalars['Int']['output'];
  subtotalCurrency: Scalars['String']['output'];
  taxRate: Scalars['Float']['output'];
  taxes: Money;
  taxesCents: Scalars['Int']['output'];
  taxesCurrency: Scalars['String']['output'];
  total: Money;
  totalCents: Scalars['Int']['output'];
  totalCurrency: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Objects which may be the subject of an Order Line Item */
export type LineItemSubject = Order | OrderProduct;

export type LinkedProductUnion = BundleProduct | ProductCondiment;

export type ListedSchool = {
  __typename?: 'ListedSchool';
  city?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  digest?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<SchoolLocation>;
  locationId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['ID']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  stateProvince?: Maybe<Scalars['String']['output']>;
  terms: Array<Maybe<Term>>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Location = {
  __typename?: 'Location';
  address?: Maybe<Address>;
  addressId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  documents: Array<Maybe<Document>>;
  id: Scalars['ID']['output'];
  imageUri?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  settings?: Maybe<Scalars['JSON']['output']>;
  taxRate?: Maybe<Scalars['Float']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type LocationRole = {
  __typename?: 'LocationRole';
  contextId: Scalars['ID']['output'];
  contextType: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  level: Scalars['Int']['output'];
  location: Location;
  locationId: Scalars['ID']['output'];
  locationType: Scalars['String']['output'];
  organization: Organization;
  organizationId: Scalars['ID']['output'];
  organizationType: Scalars['String']['output'];
  role: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
  userId: Scalars['ID']['output'];
};

export type MainDish = {
  __typename?: 'MainDish';
  assets: Array<Maybe<Asset>>;
  catalogTags: Array<Maybe<CatalogTag>>;
  condiments: Array<Maybe<Condiment>>;
  cost?: Maybe<Money>;
  costCents: Scalars['Int']['output'];
  costCurrency: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Money>;
  priceCents: Scalars['Int']['output'];
  priceCurrency: Scalars['String']['output'];
  productCondiments: Array<Maybe<ProductCondiment>>;
  productPackaging?: Maybe<ProductPackaging>;
  productRecipe?: Maybe<ProductRecipe>;
  productSelectionGroups: Array<Maybe<ProductSelectionGroup>>;
  productUtensil?: Maybe<ProductUtensil>;
  productVessels: Array<Maybe<ProductVessel>>;
  reactions: Array<Maybe<ProductReaction>>;
  recipe?: Maybe<Recipe>;
  tags: Array<Maybe<Tag>>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum MealServiceEnum {
  AmSnack = 'AM_SNACK',
  Breakfast = 'BREAKFAST',
  Lunch = 'LUNCH',
  PmSnack = 'PM_SNACK',
  Supper = 'SUPPER'
}

export type Measurement = {
  __typename?: 'Measurement';
  type: Scalars['String']['output'];
  unit: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type Menu = {
  __typename?: 'Menu';
  availabilityDates?: Maybe<Array<Scalars['ISO8601Date']['output']>>;
  availableDates?: Maybe<Array<Scalars['ISO8601Date']['output']>>;
  blockedDatetimes?: Maybe<Array<Scalars['ISO8601DateTime']['output']>>;
  blockedHolidays?: Maybe<Array<Scalars['ISO8601DateTime']['output']>>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdBy?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  endDateTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  fullAvailabilityDates?: Maybe<Array<Scalars['ISO8601Date']['output']>>;
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<SchoolLocation>;
  locationId?: Maybe<Scalars['ID']['output']>;
  locations?: Maybe<VendorLocation>;
  menuProducts?: Maybe<Array<MenuProduct>>;
  menuType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<School>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  products?: Maybe<Array<Product>>;
  sections?: Maybe<Array<MenuSection>>;
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  startDateTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  variants?: Maybe<Array<Variant>>;
};


export type MenuMenuProductsArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
};

export type MenuProduct = {
  __typename?: 'MenuProduct';
  availabilityDates?: Maybe<Array<Scalars['ISO8601Date']['output']>>;
  availableDates?: Maybe<Array<Scalars['ISO8601Date']['output']>>;
  blockedDates?: Maybe<Array<Scalars['ISO8601Date']['output']>>;
  blockedDatetimes?: Maybe<Array<Scalars['ISO8601DateTime']['output']>>;
  catalogProduct?: Maybe<ProductUnion>;
  catalogProductId?: Maybe<Scalars['ID']['output']>;
  cost: Money;
  costCents: Scalars['Int']['output'];
  costCurrency: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  datesAvailable?: Maybe<Array<Scalars['ISO8601Date']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  featuredImage?: Maybe<Scalars['String']['output']>;
  fullAvailabilityDates?: Maybe<Array<Scalars['ISO8601Date']['output']>>;
  id: Scalars['ID']['output'];
  images: Array<Maybe<Asset>>;
  lineageProducts: Array<Maybe<MenuProduct>>;
  menu?: Maybe<Menu>;
  menuId?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price: Money;
  priceCents: Scalars['Int']['output'];
  priceCurrency: Scalars['String']['output'];
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['ID']['output']>;
  productType: Scalars['String']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  rruleDays?: Maybe<Scalars['JSON']['output']>;
  section?: Maybe<Section>;
  sectionId?: Maybe<Scalars['ID']['output']>;
  sortOrder: Scalars['Int']['output'];
  tags: Array<Maybe<Tag>>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  variant?: Maybe<Variant>;
  variantId?: Maybe<Scalars['ID']['output']>;
  vendor?: Maybe<Vendor>;
  vendorLocation?: Maybe<VendorLocation>;
  vendorLocationId?: Maybe<Scalars['ID']['output']>;
  visible: Scalars['Boolean']['output'];
};

export type MenuSection = {
  __typename?: 'MenuSection';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  menuProducts?: Maybe<Array<MenuProduct>>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type Money = {
  __typename?: 'Money';
  amount: Scalars['Float']['output'];
  cents: Scalars['Int']['output'];
  currency: MoneyCurrency;
};

export type MoneyCurrency = {
  __typename?: 'MoneyCurrency';
  decimalMark: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isoCode: Scalars['String']['output'];
  isoNumeric: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  smallestDenomination: Scalars['Int']['output'];
  subunit: Scalars['String']['output'];
  subunitToUnit: Scalars['Int']['output'];
  symbol: Scalars['String']['output'];
  symbolFirst: Scalars['Boolean']['output'];
  thousandsSeparator: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addCartItem?: Maybe<AddCartItemPayload>;
  addCartItems?: Maybe<AddCartItemsPayload>;
  addProductReaction?: Maybe<AddProductReactionPayload>;
  adjustOrderItemQuantity?: Maybe<AdjustOrderItemQuantityPayload>;
  cancelOrder?: Maybe<CancelOrderPayload>;
  cancelOrderItem?: Maybe<CancelOrderItemPayload>;
  changePassword?: Maybe<ChangePasswordPayload>;
  clearCart?: Maybe<ClearCartPayload>;
  createEntityAttribute?: Maybe<CreateEntityAttributePayload>;
  createEntityAttributeSelectOption?: Maybe<CreateEntityAttributeSelectOptionPayload>;
  createOrdersFromCart?: Maybe<CreateOrdersFromCartPayload>;
  deleteEntityAttribute?: Maybe<DeleteEntityAttributePayload>;
  deleteEntityAttributeSelectOption?: Maybe<DeleteEntityAttributeSelectOptionPayload>;
  /** Identifies a user with customer.io */
  identifyUser?: Maybe<IdentifyUserPayload>;
  ignoreTodo?: Maybe<IgnoreTodoPayload>;
  removeCartItem?: Maybe<RemoveCartItemPayload>;
  removeProductReaction?: Maybe<RemoveProductReactionPayload>;
  resolveFailedPayments?: Maybe<ResolveFailedPaymentsPayload>;
  resolveTodo?: Maybe<ResolveTodoPayload>;
  updateAccountSettings?: Maybe<UpdateAccountSettingsPayload>;
  updateAccountUserSettings?: Maybe<UpdateAccountUserSettingsPayload>;
  updateCartItem?: Maybe<UpdateCartItemPayload>;
  updateEntityAttribute?: Maybe<UpdateEntityAttributePayload>;
  updateLocationSettings?: Maybe<UpdateLocationSettingsPayload>;
  updateMe?: Maybe<UpdateMePayload>;
  updateOrderStatus?: Maybe<UpdateOrderStatusPayload>;
  /** Upload and attach an image to a product */
  uploadProductImage?: Maybe<UploadProductImagePayload>;
};


export type MutationAddCartItemArgs = {
  input: AddCartItemInput;
};


export type MutationAddCartItemsArgs = {
  input: AddCartItemsInput;
};


export type MutationAddProductReactionArgs = {
  input: AddProductReactionInput;
};


export type MutationAdjustOrderItemQuantityArgs = {
  input: AdjustOrderItemQuantityInput;
};


export type MutationCancelOrderArgs = {
  input: CancelOrderInput;
};


export type MutationCancelOrderItemArgs = {
  input: CancelOrderItemInput;
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationCreateEntityAttributeArgs = {
  input: CreateEntityAttributeInput;
};


export type MutationCreateEntityAttributeSelectOptionArgs = {
  input: CreateEntityAttributeSelectOptionInput;
};


export type MutationCreateOrdersFromCartArgs = {
  input: CreateOrdersFromCartInput;
};


export type MutationDeleteEntityAttributeArgs = {
  input: DeleteEntityAttributeInput;
};


export type MutationDeleteEntityAttributeSelectOptionArgs = {
  input: DeleteEntityAttributeSelectOptionInput;
};


export type MutationIdentifyUserArgs = {
  input: IdentifyUserInput;
};


export type MutationIgnoreTodoArgs = {
  input: IgnoreTodoInput;
};


export type MutationRemoveCartItemArgs = {
  input: RemoveCartItemInput;
};


export type MutationRemoveProductReactionArgs = {
  input: RemoveProductReactionInput;
};


export type MutationResolveFailedPaymentsArgs = {
  input: ResolveFailedPaymentsInput;
};


export type MutationResolveTodoArgs = {
  input: ResolveTodoInput;
};


export type MutationUpdateAccountSettingsArgs = {
  input: UpdateAccountSettingsInput;
};


export type MutationUpdateAccountUserSettingsArgs = {
  input: UpdateAccountUserSettingsInput;
};


export type MutationUpdateCartItemArgs = {
  input: UpdateCartItemInput;
};


export type MutationUpdateEntityAttributeArgs = {
  input: UpdateEntityAttributeInput;
};


export type MutationUpdateLocationSettingsArgs = {
  input: UpdateLocationSettingsInput;
};


export type MutationUpdateMeArgs = {
  input: UpdateMeInput;
};


export type MutationUpdateOrderStatusArgs = {
  input: UpdateOrderStatusInput;
};


export type MutationUploadProductImageArgs = {
  input: UploadProductImageInput;
};

export type Order = {
  __typename?: 'Order';
  account: Account;
  accountId: Scalars['ID']['output'];
  computedStatus: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  creator: User;
  deliveryDate?: Maybe<Scalars['ISO8601Date']['output']>;
  deliveryTimestamp?: Maybe<Scalars['ISO8601DateTime']['output']>;
  discounts: Money;
  discountsCents: Scalars['Int']['output'];
  discountsCurrency: Scalars['String']['output'];
  displayStatus: Scalars['String']['output'];
  final: Money;
  finalCents: Scalars['Int']['output'];
  finalCurrency: Scalars['String']['output'];
  finalSubtotal: Money;
  finalSubtotalCents: Scalars['Int']['output'];
  finalSubtotalCurrency: Scalars['String']['output'];
  finalTaxes: Money;
  finalTaxesCents: Scalars['Int']['output'];
  finalTaxesCurrency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lineItems: Array<Maybe<LineItem>>;
  orderProducts: Array<Maybe<OrderProduct>>;
  outstanding: Money;
  outstandingCents: Scalars['Int']['output'];
  outstandingCurrency: Scalars['String']['output'];
  paymentReference?: Maybe<Scalars['JSON']['output']>;
  paymentStatus: PaymentStatus;
  quantity: Scalars['Int']['output'];
  received: Money;
  receivedCents: Scalars['Int']['output'];
  receivedCurrency: Scalars['String']['output'];
  recipient: User;
  refunded: Money;
  refundedCents: Scalars['Int']['output'];
  refundedCurrency: Scalars['String']['output'];
  shippingAmount?: Maybe<Scalars['Int']['output']>;
  sponsored: Money;
  sponsoredCents: Scalars['Int']['output'];
  sponsoredCurrency: Scalars['String']['output'];
  status: Scalars['String']['output'];
  subscription?: Maybe<Subscription>;
  subscriptionId?: Maybe<Scalars['ID']['output']>;
  subtotal: Money;
  subtotalCents: Scalars['Int']['output'];
  subtotalCurrency: Scalars['String']['output'];
  taxes: Money;
  taxesCents: Scalars['Int']['output'];
  taxesCurrency: Scalars['String']['output'];
  total: Money;
  totalCents: Scalars['Int']['output'];
  totalCurrency: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userAdjustable: Scalars['Boolean']['output'];
  userCancellable: Scalars['Boolean']['output'];
  voidedCents: Scalars['Int']['output'];
  voidedCurrency: Scalars['String']['output'];
};

export type OrderBatch = {
  __typename?: 'OrderBatch';
  account: Account;
  accountId: Scalars['ID']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  endDate: Scalars['ISO8601Date']['output'];
  error?: Maybe<Scalars['String']['output']>;
  failedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  orders: Array<Order>;
  outstanding: Money;
  outstandingCents: Scalars['Int']['output'];
  outstandingCurrency: Scalars['String']['output'];
  paymentMethodId: Scalars['String']['output'];
  processedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  queuedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  received: Money;
  receivedCents: Scalars['Int']['output'];
  receivedCurrency: Scalars['String']['output'];
  startDate: Scalars['ISO8601Date']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type OrderProduct = {
  __typename?: 'OrderProduct';
  binId?: Maybe<Scalars['ID']['output']>;
  computedStatus: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  currencyCode: Scalars['String']['output'];
  deliveryDate?: Maybe<Scalars['ISO8601Date']['output']>;
  discounts: Money;
  discountsCents: Scalars['Int']['output'];
  discountsCurrency: Scalars['String']['output'];
  displayStatus: Scalars['String']['output'];
  final: Money;
  finalCents: Scalars['Int']['output'];
  finalCurrency: Scalars['String']['output'];
  flagged: Scalars['Boolean']['output'];
  fullPrice: Money;
  fullPriceCents: Scalars['Int']['output'];
  fullPriceCurrency: Scalars['String']['output'];
  fullSubtotal: Money;
  fullSubtotalCents: Scalars['Int']['output'];
  fullSubtotalCurrency: Scalars['String']['output'];
  fullTaxes: Money;
  fullTaxesCents: Scalars['Int']['output'];
  fullTaxesCurrency: Scalars['String']['output'];
  fullTotal: Money;
  fullTotalCents: Scalars['Int']['output'];
  fullTotalCurrency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lineItems: Array<Maybe<LineItem>>;
  menu: Menu;
  menuId: Scalars['ID']['output'];
  menuProduct: MenuProduct;
  menuProductId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  order: Order;
  orderId: Scalars['ID']['output'];
  orderProduct: OrderProduct;
  orderProductId?: Maybe<Scalars['ID']['output']>;
  orderProducts: Array<Maybe<OrderProduct>>;
  outstanding: Money;
  outstandingCents: Scalars['Int']['output'];
  outstandingCurrency: Scalars['String']['output'];
  paymentStatus: PaymentStatus;
  price: Scalars['Int']['output'];
  product: Product;
  productId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  received: Money;
  receivedCents: Scalars['Int']['output'];
  receivedCurrency: Scalars['String']['output'];
  refunded: Money;
  refundedCents: Scalars['Int']['output'];
  refundedCurrency: Scalars['String']['output'];
  sponsored: Money;
  sponsoredCents: Scalars['Int']['output'];
  sponsoredCurrency: Scalars['String']['output'];
  standalone: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  subscription?: Maybe<Subscription>;
  subscriptionId?: Maybe<Scalars['ID']['output']>;
  subtotal: Money;
  subtotalCents: Scalars['Int']['output'];
  subtotalCurrency: Scalars['String']['output'];
  supportTickets: Array<Maybe<SupportTicket>>;
  taxes: Money;
  taxesCents: Scalars['Int']['output'];
  taxesCurrency: Scalars['String']['output'];
  topLevel: Scalars['Boolean']['output'];
  total: Money;
  totalCents: Scalars['Int']['output'];
  totalCurrency: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
  userAdjustable: Scalars['Boolean']['output'];
  userCancellable: Scalars['Boolean']['output'];
  userId: Scalars['ID']['output'];
  variant: Variant;
  variantId: Scalars['ID']['output'];
  voidedCents: Scalars['Int']['output'];
  voidedCurrency: Scalars['String']['output'];
};

export enum OrderScopeEnum {
  Past = 'past',
  Upcoming = 'upcoming'
}

export type Organization = {
  __typename?: 'Organization';
  billingAddressId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documents: Array<Maybe<Document>>;
  id: Scalars['ID']['output'];
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  locations?: Maybe<Array<Location>>;
  logoUri?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  physicalAddressId?: Maybe<Scalars['ID']['output']>;
  primaryContactUserId?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type OrganizationRole = {
  __typename?: 'OrganizationRole';
  contextId: Scalars['ID']['output'];
  contextType: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  level: Scalars['Int']['output'];
  organization: Organization;
  organizationId: Scalars['ID']['output'];
  organizationType: Scalars['String']['output'];
  role: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
  userId: Scalars['ID']['output'];
};

export type OrganizationUser = {
  __typename?: 'OrganizationUser';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type Packaging = {
  __typename?: 'Packaging';
  createdAt: Scalars['ISO8601DateTime']['output'];
  format: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  material: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  size: Array<Maybe<Size>>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  truncated?: Maybe<Scalars['Int']['output']>;
};

export enum PaymentStatus {
  /** Indicates all balances have been paid */
  Paid = 'PAID',
  /** Indicates a full or partial refund has been issued */
  Refunded = 'REFUNDED',
  /** Indicates there is an unpaid balance */
  Unpaid = 'UNPAID',
  /** Indicates all balances were voided */
  Void = 'VOID'
}

export type Product = {
  __typename?: 'Product';
  _cost?: Maybe<Scalars['Int']['output']>;
  catalogProduct?: Maybe<ProductUnion>;
  catalogProductId?: Maybe<Scalars['ID']['output']>;
  categoryId?: Maybe<Scalars['ID']['output']>;
  cost?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  featureImageUri?: Maybe<Scalars['String']['output']>;
  featuredImage?: Maybe<Scalars['String']['output']>;
  featuredImageUri?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUris?: Maybe<Scalars['JSON']['output']>;
  images: Array<Maybe<Asset>>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isDisabled?: Maybe<Scalars['Boolean']['output']>;
  lineageProducts: Array<Maybe<Product>>;
  listed: Scalars['Boolean']['output'];
  menuProducts: Array<Maybe<MenuProduct>>;
  menus: Array<Maybe<Menu>>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  productTags: Array<Maybe<ProductTag>>;
  productType: Scalars['String']['output'];
  tags: Array<Maybe<Tag>>;
  transitionPrice?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  variants?: Maybe<Array<Variant>>;
};


export type ProductMenusArgs = {
  includeExpired?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductPriceArgs = {
  calculate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductCondiment = {
  __typename?: 'ProductCondiment';
  condiment: Condiment;
  createdAt: Scalars['ISO8601DateTime']['output'];
  default: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  linkedId: Scalars['ID']['output'];
  product: DishUnion;
  productId: Scalars['ID']['output'];
  productSelectionGroup: ProductSelectionGroup;
  selectionGroupId: Scalars['ID']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ProductPackaging = {
  __typename?: 'ProductPackaging';
  createdAt: Scalars['ISO8601DateTime']['output'];
  essentialId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  packaging: Packaging;
  product: ConsumableUnion;
  productId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ProductReaction = {
  __typename?: 'ProductReaction';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  product: Product;
  productId: Scalars['ID']['output'];
  reaction: ProductReactionEnum;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
  userId: Scalars['ID']['output'];
};

export enum ProductReactionEnum {
  Dislike = 'dislike',
  Like = 'like'
}

export type ProductRecipe = {
  __typename?: 'ProductRecipe';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  product: ConsumableUnion;
  productId: Scalars['ID']['output'];
  recipe: Recipe;
  recipeId: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ProductSelectionGroup = {
  __typename?: 'ProductSelectionGroup';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  linkedProducts: Array<Maybe<LinkedProductUnion>>;
  productId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  required: Scalars['Int']['output'];
  selectionGroup: SelectionGroup;
  selectionGroupId: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ProductTag = {
  __typename?: 'ProductTag';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['ID']['output']>;
  tag?: Maybe<Tag>;
  tagId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum ProductTypeEnum {
  Beverages = 'beverages',
  Meals = 'meals'
}

export type ProductUnion = AddOn | Beverage | Bundle | Condiment | Dessert | MainDish | SideDish;

export type ProductUtensil = {
  __typename?: 'ProductUtensil';
  createdAt: Scalars['ISO8601DateTime']['output'];
  essentialId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  product: DishUnion;
  productId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  utensil: Utensil;
};

export type ProductVessel = {
  __typename?: 'ProductVessel';
  createdAt: Scalars['ISO8601DateTime']['output'];
  essentialId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  product: ConsumableUnion;
  productId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  vessel: Vessel;
};

export type Query = {
  __typename?: 'Query';
  accountDelinquentFor?: Maybe<Scalars['Int']['output']>;
  accountOrders: AccountOrdersPayload;
  accountSettings?: Maybe<Scalars['JSON']['output']>;
  accountTodos: TodosPayload;
  accountUser: AccountUser;
  accountUserSettings?: Maybe<Scalars['JSON']['output']>;
  accountUsers: Array<AccountUser>;
  activeMenu?: Maybe<Menu>;
  activeMenus: Array<Menu>;
  entityAttribute: EntityAttributeUnion;
  entityAttributes: Array<EntityAttributeUnion>;
  kioskUsers: Array<Maybe<KioskUser>>;
  listedSchools: Array<ListedSchool>;
  locationDocuments: Array<Maybe<Document>>;
  locationSettings?: Maybe<Scalars['JSON']['output']>;
  me?: Maybe<User>;
  menu: Menu;
  menuDisplayName?: Maybe<Scalars['String']['output']>;
  menuIsActive?: Maybe<Scalars['Boolean']['output']>;
  menuName?: Maybe<Scalars['String']['output']>;
  menuProductAvailabilityDates?: Maybe<Array<Scalars['ISO8601Date']['output']>>;
  menuProducts?: Maybe<Array<MenuProduct>>;
  myCart?: Maybe<Cart>;
  myOrders: Array<Maybe<Order>>;
  orderPaymentStatus?: Maybe<PaymentStatus>;
  orderProductPaymentStatus?: Maybe<PaymentStatus>;
  orderedProduct?: Maybe<Product>;
  productFeaturedImageUri?: Maybe<Scalars['String']['output']>;
  productImageAssets?: Maybe<Array<Asset>>;
  statesProvinces: Array<Maybe<StateProvince>>;
  userAccounts: Array<Maybe<Account>>;
  validateCart: CartValidationPayload;
};


export type QueryAccountDelinquentForArgs = {
  accountId: Scalars['ID']['input'];
};


export type QueryAccountOrdersArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  filters?: InputMaybe<QueryFiltersInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sorting?: InputMaybe<Array<InputMaybe<QuerySortInput>>>;
};


export type QueryAccountSettingsArgs = {
  accountId: Scalars['ID']['input'];
};


export type QueryAccountTodosArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  filters?: InputMaybe<QueryFiltersInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sorting?: InputMaybe<Array<InputMaybe<QuerySortInput>>>;
};


export type QueryAccountUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAccountUserSettingsArgs = {
  accountUserId: Scalars['ID']['input'];
};


export type QueryAccountUsersArgs = {
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryActiveMenuArgs = {
  locationId: Scalars['ID']['input'];
};


export type QueryActiveMenusArgs = {
  locationIds: Array<Scalars['ID']['input']>;
};


export type QueryEntityAttributeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryKioskUsersArgs = {
  date: Scalars['ISO8601Date']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryListedSchoolsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLocationDocumentsArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLocationSettingsArgs = {
  locationId: Scalars['ID']['input'];
};


export type QueryMenuArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMenuDisplayNameArgs = {
  menuId: Scalars['ID']['input'];
};


export type QueryMenuIsActiveArgs = {
  menuId: Scalars['ID']['input'];
};


export type QueryMenuNameArgs = {
  menuId: Scalars['ID']['input'];
};


export type QueryMenuProductAvailabilityDatesArgs = {
  menuProductId: Scalars['ID']['input'];
};


export type QueryMenuProductsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMyOrdersArgs = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<OrderScopeEnum>;
};


export type QueryOrderPaymentStatusArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrderProductPaymentStatusArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrderedProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductFeaturedImageUriArgs = {
  productId: Scalars['ID']['input'];
};


export type QueryProductImageAssetsArgs = {
  productId: Scalars['ID']['input'];
};


export type QueryUserAccountsArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryValidateCartArgs = {
  cartId: Scalars['ID']['input'];
};

export type QueryAggregation = {
  __typename?: 'QueryAggregation';
  buckets: Array<Maybe<QueryAggregationBucket>>;
  field: Scalars['String']['output'];
};

export type QueryAggregationBucket = {
  __typename?: 'QueryAggregationBucket';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  total: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type QueryFilterInput = {
  field: Scalars['String']['input'];
  logicOperator?: InputMaybe<QueryFilterLogicOperatorEnum>;
  operator?: InputMaybe<QueryFilterOperatorEnum>;
  value: Array<Scalars['String']['input']>;
};

export enum QueryFilterLogicOperatorEnum {
  And = 'and',
  Or = 'or'
}

export enum QueryFilterOperatorEnum {
  Equal = 'equal',
  Greater = 'greater',
  GreaterOrEqual = 'greater_or_equal',
  Less = 'less',
  LessOrEqual = 'less_or_equal',
  Match = 'match',
  NotEqual = 'not_equal'
}

export type QueryFiltersInput = {
  filters: Array<QueryFilterInput>;
  logicOperator?: InputMaybe<QueryFilterLogicOperatorEnum>;
};

export enum QuerySortDirectionEnum {
  Asc = 'asc',
  Desc = 'desc'
}

export type QuerySortInput = {
  field: Scalars['String']['input'];
  sort: QuerySortDirectionEnum;
};

export type Recipe = {
  __typename?: 'Recipe';
  cookTime?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  prepTime?: Maybe<Scalars['Int']['output']>;
  recipeIngredients: Array<Maybe<RecipeIngredient>>;
  recipeInstructions: Array<Maybe<RecipeInstruction>>;
  totalTime?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  yield?: Maybe<Scalars['Int']['output']>;
};

export type RecipeIngredient = {
  __typename?: 'RecipeIngredient';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  ingredient: Ingredient;
  ingredientId: Scalars['ID']['output'];
  measurement?: Maybe<Measurement>;
  measurementUnit?: Maybe<Scalars['String']['output']>;
  measurementValue?: Maybe<Scalars['Float']['output']>;
  qty: Measurement;
  quantity: Scalars['Int']['output'];
  quantityUnit: Scalars['String']['output'];
  quantityValue: Scalars['Int']['output'];
  recipe: Recipe;
  recipeId: Scalars['ID']['output'];
  size?: Maybe<Measurement>;
  sizeUnit?: Maybe<Scalars['String']['output']>;
  sizeValue?: Maybe<Scalars['Float']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  volume?: Maybe<Measurement>;
  volumeUnit?: Maybe<Scalars['String']['output']>;
  volumeValue?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Measurement>;
  weightUnit?: Maybe<Scalars['String']['output']>;
  weightValue?: Maybe<Scalars['Float']['output']>;
};

export type RecipeInstruction = {
  __typename?: 'RecipeInstruction';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  recipeId: Scalars['ID']['output'];
  recipeInstructionIngredients: Array<Maybe<RecipeInstructionIngredient>>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type RecipeInstructionIngredient = {
  __typename?: 'RecipeInstructionIngredient';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  qty: Measurement;
  quantity: Scalars['Int']['output'];
  quantityUnit: Scalars['String']['output'];
  quantityValue: Scalars['Int']['output'];
  recipeIngredient: RecipeIngredient;
  recipeIngredientId: Scalars['ID']['output'];
  recipeInstruction: RecipeInstruction;
  recipeInstructionId: Scalars['ID']['output'];
  size: Size;
  sizeUnit: Scalars['String']['output'];
  sizeValue: Scalars['Float']['output'];
  sortOrder?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of RemoveCartItem */
export type RemoveCartItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveCartItem */
export type RemoveCartItemPayload = {
  __typename?: 'RemoveCartItemPayload';
  cart?: Maybe<Cart>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ClientError>;
};

/** Autogenerated input type of RemoveProductReaction */
export type RemoveProductReactionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveProductReaction */
export type RemoveProductReactionPayload = {
  __typename?: 'RemoveProductReactionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ClientError>;
  reaction?: Maybe<ProductReaction>;
};

/** Autogenerated input type of ResolveFailedPayments */
export type ResolveFailedPaymentsInput = {
  /** Account ID */
  accountId: Scalars['ID']['input'];
  /** Batch ID(s) */
  batchIds: Array<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Selected payment method ID */
  paymentMethodId: Scalars['String']['input'];
};

/** Autogenerated return type of ResolveFailedPayments */
export type ResolveFailedPaymentsPayload = {
  __typename?: 'ResolveFailedPaymentsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** An array of errors that are presentable by the client. */
  errors: Array<ClientError>;
  orderBatches?: Maybe<Array<OrderBatch>>;
};

/** Autogenerated input type of ResolveTodo */
export type ResolveTodoInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  todoId: Scalars['ID']['input'];
};

/** Autogenerated return type of ResolveTodo */
export type ResolveTodoPayload = {
  __typename?: 'ResolveTodoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** An array of errors that are presentable by the client. */
  errors: Array<ClientError>;
  todo?: Maybe<TodoTask>;
};

export type Roster = {
  __typename?: 'Roster';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  group: Scalars['String']['output'];
  groupName: Scalars['String']['output'];
  homeroom?: Maybe<Homeroom>;
  homeroomId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  isFilterable: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  rosterUsers?: Maybe<Array<RosterUser>>;
  sortOrder: Scalars['Int']['output'];
  term: Term;
  termId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type RosterUser = {
  __typename?: 'RosterUser';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  roster?: Maybe<Roster>;
  rosterId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type School = {
  __typename?: 'School';
  billingAddressId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documents: Array<Maybe<Document>>;
  id: Scalars['ID']['output'];
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  locations?: Maybe<Array<SchoolLocation>>;
  logoUri?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  physicalAddressId?: Maybe<Scalars['ID']['output']>;
  primaryContactUserId?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type SchoolLocation = {
  __typename?: 'SchoolLocation';
  activeTerm?: Maybe<Term>;
  activeTerms: Array<Maybe<Term>>;
  address?: Maybe<Address>;
  addressId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  documentTypeOptions: Array<SelectOption>;
  documents: Array<Maybe<Document>>;
  id: Scalars['ID']['output'];
  imageUri?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  school?: Maybe<School>;
  settings?: Maybe<Scalars['JSON']['output']>;
  taxRate?: Maybe<Scalars['Float']['output']>;
  terms?: Maybe<Array<Term>>;
  timeZone?: Maybe<Scalars['String']['output']>;
  todoCount: Scalars['Int']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type Section = {
  __typename?: 'Section';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type SelectOption = {
  __typename?: 'SelectOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SelectionGroup = {
  __typename?: 'SelectionGroup';
  createdAt: Scalars['ISO8601DateTime']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type SideDish = {
  __typename?: 'SideDish';
  assets: Array<Maybe<Asset>>;
  catalogTags: Array<Maybe<CatalogTag>>;
  condiments: Array<Maybe<Condiment>>;
  cost?: Maybe<Money>;
  costCents: Scalars['Int']['output'];
  costCurrency: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Money>;
  priceCents: Scalars['Int']['output'];
  priceCurrency: Scalars['String']['output'];
  productCondiments: Array<Maybe<ProductCondiment>>;
  productPackaging?: Maybe<ProductPackaging>;
  productRecipe?: Maybe<ProductRecipe>;
  productSelectionGroups: Array<Maybe<ProductSelectionGroup>>;
  productUtensil?: Maybe<ProductUtensil>;
  productVessels: Array<Maybe<ProductVessel>>;
  reactions: Array<Maybe<ProductReaction>>;
  recipe?: Maybe<Recipe>;
  tags: Array<Maybe<Tag>>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Size = {
  __typename?: 'Size';
  unit: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type StateProvince = {
  __typename?: 'StateProvince';
  abbreviation: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  accountUser: AccountUser;
  accountUserId: Scalars['ID']['output'];
  availableSubscriptionTags: Array<Maybe<Tag>>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  dailyOptions: SubscriptionDailyOptions;
  id: Scalars['ID']['output'];
  pauseUntil?: Maybe<Scalars['ISO8601Date']['output']>;
  status: SubscriptionStatusEnum;
  subscriptionOptions: SubscriptionOptions;
  subscriptionTags: Array<Maybe<SubscriptionTag>>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
};

export type SubscriptionDailyOption = {
  __typename?: 'SubscriptionDailyOption';
  active: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
};

export type SubscriptionDailyOptions = {
  __typename?: 'SubscriptionDailyOptions';
  friday: SubscriptionDailyOption;
  monday: SubscriptionDailyOption;
  saturday: SubscriptionDailyOption;
  sunday: SubscriptionDailyOption;
  thursday: SubscriptionDailyOption;
  tuesday: SubscriptionDailyOption;
  wednesday: SubscriptionDailyOption;
};

export type SubscriptionMenuSlot = {
  __typename?: 'SubscriptionMenuSlot';
  active: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  mealService: MealServiceEnum;
  menuType: Scalars['String']['output'];
  productSlots: Array<SubscriptionProductSlot>;
  slotName: Scalars['String']['output'];
};

export type SubscriptionOptions = {
  __typename?: 'SubscriptionOptions';
  menuSlots: Array<Maybe<SubscriptionMenuSlot>>;
};

export type SubscriptionProductSlot = {
  __typename?: 'SubscriptionProductSlot';
  enabled: Scalars['Boolean']['output'];
  productType: ProductTypeEnum;
  quantity: Scalars['Int']['output'];
  slotName: Scalars['String']['output'];
};

export enum SubscriptionStatusEnum {
  Cancelled = 'cancelled',
  Enabled = 'enabled',
  Initialized = 'initialized',
  Paused = 'paused'
}

export type SubscriptionTag = {
  __typename?: 'SubscriptionTag';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  subscription?: Maybe<Subscription>;
  subscriptionId?: Maybe<Scalars['ID']['output']>;
  tag?: Maybe<Tag>;
  tagId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type SupportTicket = {
  __typename?: 'SupportTicket';
  affected: User;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  orderProducts: Array<Maybe<OrderProduct>>;
  reporter: User;
  status: SupportTicketStatusEnum;
  ticketType: Scalars['String']['output'];
  unresolved: Scalars['Boolean']['output'];
};

export enum SupportTicketStatusEnum {
  Ignored = 'ignored',
  InProgress = 'in_progress',
  Inbound = 'inbound',
  Resolved = 'resolved'
}

export type Tag = {
  __typename?: 'Tag';
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subscriptionTag?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type Term = {
  __typename?: 'Term';
  blockedDates?: Maybe<Array<Scalars['ISO8601Date']['output']>>;
  blockedDatetimes?: Maybe<Array<Scalars['ISO8601DateTime']['output']>>;
  blockedHolidays?: Maybe<Array<Scalars['ISO8601DateTime']['output']>>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  documents: Array<Maybe<Document>>;
  endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  endDateTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  exclusionDates?: Maybe<Scalars['JSON']['output']>;
  homerooms?: Maybe<Array<Homeroom>>;
  id: Scalars['ID']['output'];
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<SchoolLocation>;
  locationId?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  rosters?: Maybe<Array<Roster>>;
  rrule?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  startDateTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  todoCount: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type TodoDefinition = {
  __typename?: 'TodoDefinition';
  blocking?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  definition: Scalars['JSON']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  level?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  onboarding: Scalars['Boolean']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  subjectType: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type TodoSubjectUnion = Account | AccountUser | School | SchoolLocation | Term | User | Vendor | VendorLocation;

export type TodoTask = {
  __typename?: 'TodoTask';
  available: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  definition: TodoDefinition;
  definitionId: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata: Scalars['JSON']['output'];
  name: Scalars['String']['output'];
  resolved: Scalars['Boolean']['output'];
  status: TodoTaskStatusEnum;
  subject: TodoSubjectUnion;
  subjectId: Scalars['ID']['output'];
  subjectType: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export enum TodoTaskStatusEnum {
  Completed = 'completed',
  Ignored = 'ignored',
  Incomplete = 'incomplete'
}

export type TodosPayload = {
  __typename?: 'TodosPayload';
  aggregations: Array<Maybe<QueryAggregation>>;
  /** An array of errors that are presentable by the client. */
  errors: Array<Maybe<ClientError>>;
  pageInfo?: Maybe<PageInfo>;
  rowCount?: Maybe<Scalars['Int']['output']>;
  rows: Array<Maybe<TodoTask>>;
};

/** Autogenerated input type of UpdateAccountSettings */
export type UpdateAccountSettingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Account ID */
  id: Scalars['ID']['input'];
  /** payload of attributes to update */
  settings: Scalars['JSON']['input'];
};

/** Autogenerated return type of UpdateAccountSettings */
export type UpdateAccountSettingsPayload = {
  __typename?: 'UpdateAccountSettingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** An array of errors that are presentable by the client. */
  errors: Array<ClientError>;
  settings?: Maybe<Scalars['JSON']['output']>;
};

/** Autogenerated input type of UpdateAccountUserSettings */
export type UpdateAccountUserSettingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Account User ID */
  id: Scalars['ID']['input'];
  /** payload of attributes to update */
  settings: Scalars['JSON']['input'];
};

/** Autogenerated return type of UpdateAccountUserSettings */
export type UpdateAccountUserSettingsPayload = {
  __typename?: 'UpdateAccountUserSettingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** An array of errors that are presentable by the client. */
  errors: Array<ClientError>;
  settings?: Maybe<Scalars['JSON']['output']>;
};

/** Autogenerated input type of UpdateCartItem */
export type UpdateCartItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  price?: InputMaybe<Scalars['Int']['input']>;
  quantity: Scalars['Int']['input'];
};

/** Autogenerated return type of UpdateCartItem */
export type UpdateCartItemPayload = {
  __typename?: 'UpdateCartItemPayload';
  cart?: Maybe<Cart>;
  cartItem?: Maybe<CartItem>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** An array of errors that are presentable by the client. */
  errors: Array<ClientError>;
};

/** Autogenerated input type of UpdateEntityAttribute */
export type UpdateEntityAttributeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** EntityAttribute ID */
  id: Scalars['ID']['input'];
  /** new name for the entity attribute */
  name?: InputMaybe<Scalars['String']['input']>;
  /** new status for the entity attribute */
  status?: InputMaybe<EntityAttributeStatusEnum>;
};

/** Autogenerated return type of UpdateEntityAttribute */
export type UpdateEntityAttributePayload = {
  __typename?: 'UpdateEntityAttributePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entityAttribute?: Maybe<EntityAttributeUnion>;
  /** An array of errors that are presentable by the client. */
  errors: Array<ClientError>;
};

/** Autogenerated input type of UpdateLocationSettings */
export type UpdateLocationSettingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Location ID */
  id: Scalars['ID']['input'];
  /** payload of attributes to update */
  settings: Scalars['JSON']['input'];
};

/** Autogenerated return type of UpdateLocationSettings */
export type UpdateLocationSettingsPayload = {
  __typename?: 'UpdateLocationSettingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** An array of errors that are presentable by the client. */
  errors: Array<ClientError>;
  settings?: Maybe<Scalars['JSON']['output']>;
};

/** Autogenerated input type of UpdateMe */
export type UpdateMeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateMe */
export type UpdateMePayload = {
  __typename?: 'UpdateMePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** An array of errors that are presentable by the client. */
  errors: Array<Maybe<ClientError>>;
  me?: Maybe<User>;
};

/** Autogenerated input type of UpdateOrderStatus */
export type UpdateOrderStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderIds: Array<Scalars['ID']['input']>;
  status: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateOrderStatus */
export type UpdateOrderStatusPayload = {
  __typename?: 'UpdateOrderStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  orders: Array<Order>;
};

/** Autogenerated input type of UploadProductImage */
export type UploadProductImageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  image: Scalars['Upload']['input'];
  productId: Scalars['ID']['input'];
};

/** Autogenerated return type of UploadProductImage */
export type UploadProductImagePayload = {
  __typename?: 'UploadProductImagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  product: Product;
};

export type User = {
  __typename?: 'User';
  account?: Maybe<Account>;
  accountLocations?: Maybe<Array<Location>>;
  accountUser?: Maybe<AccountUser>;
  accounts: Array<Maybe<Account>>;
  activeRosterUsers?: Maybe<Array<RosterUser>>;
  activeRosters: Array<Maybe<Roster>>;
  avatarUri?: Maybe<Scalars['String']['output']>;
  birthday?: Maybe<Scalars['ISO8601Date']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdBy?: Maybe<User>;
  currentRosterUsers?: Maybe<Array<RosterUser>>;
  displayName?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  features: Array<Maybe<UserFeature>>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  locations?: Maybe<Array<Location>>;
  middleName?: Maybe<Scalars['String']['output']>;
  orders: Array<Maybe<Order>>;
  organizationLocations?: Maybe<Array<Location>>;
  organizationUser?: Maybe<OrganizationUser>;
  organizationUsers?: Maybe<Array<OrganizationUser>>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  preferredName?: Maybe<Scalars['String']['output']>;
  pronouns?: Maybe<Scalars['String']['output']>;
  reactions: Array<Maybe<ProductReaction>>;
  roster?: Maybe<Roster>;
  rosterUser?: Maybe<RosterUser>;
  rosterUsers?: Maybe<Array<RosterUser>>;
  rosters?: Maybe<Array<Maybe<Roster>>>;
  schoolLocations: Array<Maybe<SchoolLocation>>;
  schools?: Maybe<Array<School>>;
  suffix?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  userRoles?: Maybe<Array<UserRole>>;
  vendorLocations: Array<Maybe<VendorLocation>>;
  vendors?: Maybe<Array<Vendor>>;
};


export type UserRosterArgs = {
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
};

export type UserFeature = {
  __typename?: 'UserFeature';
  enabled: Scalars['Boolean']['output'];
  featureFlag: FeatureFlag;
  key: Scalars['String']['output'];
};

/** Top-level user role union */
export type UserRole = AccountRole | AdminRole | LocationRole | OrganizationRole;

export type Utensil = {
  __typename?: 'Utensil';
  createdAt: Scalars['ISO8601DateTime']['output'];
  format: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  material: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Variant = {
  __typename?: 'Variant';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<VendorLocation>;
  product?: Maybe<Product>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type Vendor = {
  __typename?: 'Vendor';
  billingAddressId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documents: Array<Maybe<Document>>;
  id: Scalars['ID']['output'];
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  locations?: Maybe<Array<VendorLocation>>;
  logoUri?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  physicalAddressId?: Maybe<Scalars['ID']['output']>;
  primaryContactUserId?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type VendorLocation = {
  __typename?: 'VendorLocation';
  address?: Maybe<Address>;
  addressId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  documentTypeOptions: Array<SelectOption>;
  documents: Array<Maybe<Document>>;
  id: Scalars['ID']['output'];
  imageUri?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  settings?: Maybe<Scalars['JSON']['output']>;
  taxRate?: Maybe<Scalars['Float']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  todoCount: Scalars['Int']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  vendor?: Maybe<Vendor>;
};

export type Vessel = {
  __typename?: 'Vessel';
  createdAt: Scalars['ISO8601DateTime']['output'];
  format: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  material: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  size: Array<Maybe<Size>>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type DocumentFragmentFragment = { __typename?: 'Document', id: string, organizationId: string, locationId?: string | null, termId?: string | null, documentType: string, archived: boolean, expired: boolean, expiresAt?: any | null, title: string, file: string, createdAt: any } & { ' $fragmentName'?: 'DocumentFragmentFragment' };

export type MeFragmentFragment = { __typename?: 'User', id: string, firstName?: string | null, middleName?: string | null, lastName?: string | null, preferredName?: string | null, emailAddress?: string | null, features: Array<{ __typename?: 'UserFeature', key: string, enabled: boolean } | null>, account?: { __typename?: 'Account', id: string, name?: string | null, accountUsers?: Array<{ __typename?: 'AccountUser', id: string, user?: { __typename?: 'User', id: string, firstName?: string | null, middleName?: string | null, lastName?: string | null, preferredName?: string | null, displayName?: string | null, features: Array<{ __typename?: 'UserFeature', key: string, enabled: boolean } | null>, roster?: { __typename?: 'Roster', id: string, name: string, description?: string | null, displayName: string, group: string, groupName: string, sortOrder: number, term: { __typename?: 'Term', id: string, name?: string | null, location?: { __typename?: 'SchoolLocation', id: string, name?: string | null, displayName?: string | null, timeZone?: string | null, organization?: { __typename?: 'Organization', id: string, name?: string | null } | null } | null } } | null } | null, location?: { __typename?: 'SchoolLocation', id: string, name?: string | null, displayName?: string | null, timeZone?: string | null, organization?: { __typename?: 'Organization', id: string, name?: string | null } | null } | null }> | null } | null, schoolLocations: Array<{ __typename?: 'SchoolLocation', id: string, name?: string | null, timeZone?: string | null, todoCount: number, organization?: { __typename?: 'Organization', id: string, name?: string | null } | null, activeTerm?: { __typename?: 'Term', id: string, name?: string | null, startDate?: any | null, endDate?: any | null, todoCount: number } | null, terms?: Array<{ __typename?: 'Term', id: string, name?: string | null, startDate?: any | null, endDate?: any | null, todoCount: number }> | null } | null>, vendorLocations: Array<{ __typename?: 'VendorLocation', id: string, name?: string | null, timeZone?: string | null, todoCount: number, organization?: { __typename?: 'Organization', id: string, name?: string | null } | null } | null>, userRoles?: Array<{ __typename?: 'AccountRole', role: string, level: number, contextType: string, contextId: string, accountId: string } | { __typename?: 'AdminRole', role: string, level: number } | { __typename?: 'LocationRole', role: string, level: number, contextType: string, contextId: string, organizationType: string, organizationId: string, locationType: string, locationId: string } | { __typename?: 'OrganizationRole', role: string, level: number, contextType: string, contextId: string, organizationType: string, organizationId: string }> | null } & { ' $fragmentName'?: 'MeFragmentFragment' };

export type TodoFragmentFragment = { __typename?: 'TodoTask', id: string, name: string, summary?: string | null, description?: string | null, status: TodoTaskStatusEnum, available: boolean, resolved: boolean, metadata: any, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, subject: { __typename?: 'Account' } | { __typename?: 'AccountUser' } | { __typename?: 'School' } | { __typename?: 'SchoolLocation' } | { __typename?: 'Term' } | { __typename?: 'User' } | { __typename?: 'Vendor', id: string, name?: string | null } | { __typename?: 'VendorLocation', id: string, name?: string | null }, definition: { __typename?: 'TodoDefinition', id: string, definition: any, type?: string | null, required?: boolean | null, blocking?: boolean | null, onboarding: boolean, role?: string | null, level?: number | null } } & { ' $fragmentName'?: 'TodoFragmentFragment' };

export type ChangePasswordMutationMutationVariables = Exact<{
  input: ChangePasswordInput;
}>;


export type ChangePasswordMutationMutation = { __typename?: 'Mutation', changePassword?: { __typename?: 'ChangePasswordPayload', token?: string | null, refreshToken?: string | null, errors: Array<{ __typename?: 'ClientError', code?: string | null, message: string } | null> } | null };

export type IgnoreTodoMutationMutationVariables = Exact<{
  input: IgnoreTodoInput;
}>;


export type IgnoreTodoMutationMutation = { __typename?: 'Mutation', ignoreTodo?: { __typename?: 'IgnoreTodoPayload', todo?: (
      { __typename?: 'TodoTask' }
      & { ' $fragmentRefs'?: { 'TodoFragmentFragment': TodoFragmentFragment } }
    ) | null, errors: Array<{ __typename?: 'ClientError', code?: string | null, message: string, path?: Array<string> | null }> } | null };

export type ResolveTodoMutationMutationVariables = Exact<{
  input: ResolveTodoInput;
}>;


export type ResolveTodoMutationMutation = { __typename?: 'Mutation', resolveTodo?: { __typename?: 'ResolveTodoPayload', todo?: (
      { __typename?: 'TodoTask' }
      & { ' $fragmentRefs'?: { 'TodoFragmentFragment': TodoFragmentFragment } }
    ) | null, errors: Array<{ __typename?: 'ClientError', code?: string | null, message: string, path?: Array<string> | null }> } | null };

export type UpdateMeMutationMutationVariables = Exact<{
  input: UpdateMeInput;
}>;


export type UpdateMeMutationMutation = { __typename?: 'Mutation', updateMe?: { __typename?: 'UpdateMePayload', me?: (
      { __typename?: 'User' }
      & { ' $fragmentRefs'?: { 'MeFragmentFragment': MeFragmentFragment } }
    ) | null, errors: Array<{ __typename?: 'ClientError', code?: string | null, message: string, path?: Array<string> | null } | null> } | null };

export type ListedSchoolsQueryQueryVariables = Exact<{
  state?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListedSchoolsQueryQuery = { __typename?: 'Query', listedSchools: Array<{ __typename?: 'ListedSchool', id: string, name: string, description?: string | null, city?: string | null, locationId?: string | null, createdAt: any, updatedAt: any, terms: Array<{ __typename?: 'Term', id: string, name?: string | null, rosters?: Array<{ __typename?: 'Roster', id: string, name: string, description?: string | null, displayName: string, group: string, groupName: string, sortOrder: number, isVisible: boolean, isArchived: boolean }> | null } | null> }> };

export type LocationDocumentsQueryQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type LocationDocumentsQueryQuery = { __typename?: 'Query', locationDocuments: Array<(
    { __typename?: 'Document' }
    & { ' $fragmentRefs'?: { 'DocumentFragmentFragment': DocumentFragmentFragment } }
  ) | null> };

export type MeQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQueryQuery = { __typename?: 'Query', me?: (
    { __typename?: 'User' }
    & { ' $fragmentRefs'?: { 'MeFragmentFragment': MeFragmentFragment } }
  ) | null };

export type StatesProvincesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type StatesProvincesQueryQuery = { __typename?: 'Query', statesProvinces: Array<{ __typename?: 'StateProvince', id: string, name: string, abbreviation: string } | null> };

export const DocumentFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"documentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Document"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"termId"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"expired"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"file"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<DocumentFragmentFragment, unknown>;
export const MeFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"meFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"preferredName"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"accountUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"preferredName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roster"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"group"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"term"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"schoolLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"todoCount"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activeTerm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"todoCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"terms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"todoCount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"todoCount"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdminRole"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"level"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountRole"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"contextType"}},{"kind":"Field","name":{"kind":"Name","value":"contextId"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationRole"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"contextType"}},{"kind":"Field","name":{"kind":"Name","value":"contextId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationType"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LocationRole"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"contextType"}},{"kind":"Field","name":{"kind":"Name","value":"contextId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationType"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"locationType"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}}]}}]}}]}}]} as unknown as DocumentNode<MeFragmentFragment, unknown>;
export const TodoFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"todoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TodoTask"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"resolved"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Vendor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorLocation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"definition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"definition"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"blocking"}},{"kind":"Field","name":{"kind":"Name","value":"onboarding"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"level"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]} as unknown as DocumentNode<TodoFragmentFragment, unknown>;
export const ChangePasswordMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"changePasswordMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangePasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changePassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ChangePasswordMutationMutation, ChangePasswordMutationMutationVariables>;
export const IgnoreTodoMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ignoreTodoMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IgnoreTodoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ignoreTodo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"todo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"todoFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"todoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TodoTask"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"resolved"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Vendor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorLocation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"definition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"definition"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"blocking"}},{"kind":"Field","name":{"kind":"Name","value":"onboarding"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"level"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]} as unknown as DocumentNode<IgnoreTodoMutationMutation, IgnoreTodoMutationMutationVariables>;
export const ResolveTodoMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"resolveTodoMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResolveTodoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resolveTodo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"todo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"todoFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"todoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TodoTask"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"resolved"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Vendor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorLocation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"definition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"definition"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"blocking"}},{"kind":"Field","name":{"kind":"Name","value":"onboarding"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"level"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]} as unknown as DocumentNode<ResolveTodoMutationMutation, ResolveTodoMutationMutationVariables>;
export const UpdateMeMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateMeMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateMeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMe"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"meFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"meFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"preferredName"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"accountUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"preferredName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roster"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"group"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"term"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"schoolLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"todoCount"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activeTerm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"todoCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"terms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"todoCount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"todoCount"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdminRole"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"level"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountRole"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"contextType"}},{"kind":"Field","name":{"kind":"Name","value":"contextId"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationRole"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"contextType"}},{"kind":"Field","name":{"kind":"Name","value":"contextId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationType"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LocationRole"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"contextType"}},{"kind":"Field","name":{"kind":"Name","value":"contextId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationType"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"locationType"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateMeMutationMutation, UpdateMeMutationMutationVariables>;
export const ListedSchoolsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listedSchoolsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listedSchools"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"terms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rosters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"group"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isVisible"}},{"kind":"Field","name":{"kind":"Name","value":"isArchived"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListedSchoolsQueryQuery, ListedSchoolsQueryQueryVariables>;
export const LocationDocumentsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"locationDocumentsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationDocuments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"documentFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"documentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Document"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"termId"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"expired"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"file"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<LocationDocumentsQueryQuery, LocationDocumentsQueryQueryVariables>;
export const MeQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"meQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"meFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"meFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"preferredName"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"accountUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"preferredName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roster"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"group"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"term"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"schoolLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"todoCount"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activeTerm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"todoCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"terms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"todoCount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"todoCount"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdminRole"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"level"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountRole"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"contextType"}},{"kind":"Field","name":{"kind":"Name","value":"contextId"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationRole"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"contextType"}},{"kind":"Field","name":{"kind":"Name","value":"contextId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationType"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LocationRole"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"contextType"}},{"kind":"Field","name":{"kind":"Name","value":"contextId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationType"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"locationType"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}}]}}]}}]}}]} as unknown as DocumentNode<MeQueryQuery, MeQueryQueryVariables>;
export const StatesProvincesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"statesProvincesQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statesProvinces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}}]}}]} as unknown as DocumentNode<StatesProvincesQueryQuery, StatesProvincesQueryQueryVariables>;